import { request } from "../utils/request.js"


export const versionRecord_getLastVersionInfoByTenantCode = (tenantCode) => request({
    url: 'versionRecord/getLastVersionInfoByTenantCode',
    method: 'GET',
    params: { tenantCode: tenantCode },
})


export const expRequest_addNew = (param) => request({
    url: 'expRequest/addNew',
    method: 'POST',
    params: param,
})



// WEBPACK FOOTER //
// ./src/api/api.js